import { useMsal } from "@azure/msal-react";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { authAPI, searchAPI } from "services/apis.service";
import { useDispatch } from "react-redux";
import { setsearch, setsidebarDataCopy } from "context/features/dataSlice";
import { loginUser, logoutUser } from "context/features/authSlice";
import { toast } from "react-toastify";
import CustomLoader from "components/base/loader";
import { consumeOAuthSignupContext } from "hooks/use-auth.hook";

export default function NYCSSOLogin() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

   const setSidebar = async (data) => {
    try {
    const sidebar = await axios.post(
    searchAPI.sidebar,
    {
        callingUserId: data.userId,
        userId: data.userId,
        includeDeletedRecords: 0,
    },
    {
        headers: {
        Authorization: `Bearer ${data.token}`,
        },
    }
    );

    dispatch(setsidebarDataCopy(sidebar.data));
    } catch (e) {
    console.error(e);
    }
    };

  const handleNYCLogin = async (provider) => {
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get("code");

    if (code) {
      dispatch(logoutUser());
      localStorage.removeItem("user");
      dispatch(setsearch(""));
      try {
        const res = await axios.post(`${authAPI.nycLogin}`, {
          code,
          provider,
          ...consumeOAuthSignupContext(),
        });
        localStorage.setItem("user", JSON.stringify(res.data));
        localStorage.setItem("login", true);
        setSidebar(res.data);

        dispatch(loginUser({ user: res.data }));
        localStorage.setItem("email", res.data.email);
        localStorage.setItem("NycDoe", code);
        navigate("/");
      } catch (error) {
        console.error("Error sending the code to backend:", error);
        toast.error("There was an issue logging in with NYC SSO.");
        navigate("/");
      }
    } else {
      toast.error("Cannot login in at NYC SSO");
      navigate("/");
    }
  };

  useEffect(() => {
    handleNYCLogin("NycDoe");
  }, [location.search]);

  return (
    <div className="circular-loader-center">
      <CustomLoader />
    </div>
  );
};
